import { AccountSummary } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Account = {
  id: number;
  name: string;
};

export const fromGql = (item: AccountSummary): Account =>
  take(item, 'id', 'name');
